import { render } from "./productlist-widget.vue?vue&type=template&id=14b206b8&scoped=true"
import script from "./productlist-widget.vue?vue&type=script&lang=js"
export * from "./productlist-widget.vue?vue&type=script&lang=js"

import "./productlist-widget.vue?vue&type=style&index=0&id=14b206b8&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b206b8"]])

export default __exports__